var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Reward",style:(_vm.inputColor)},[_c('div',{staticClass:"text"},[_c('div',{staticClass:"title fs24"},[_vm._v(_vm._s(_vm.reward.title))]),_c('div',{staticClass:"content fs18"},[_vm._v(_vm._s(_vm.reward.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }